/* eslint-disable camelcase */

export const generateProductUrl = ({
    url: productSlug,
    model_id,
    article_id,
}) => {
    const mailUrl = `/p/${productSlug}-${article_id}`;

    if (model_id !== article_id) {
        return `${mailUrl}?model_id=${model_id}`;
    }
    return mailUrl;
};

export const PRODUCT_CARD_MODE = {
    GRID: 'grid-default',
    GRID_VISUAL: 'grid-visual',
    LIST: 'list-default',
    LIST_SPEC: 'list-spec',
};

export const showAsList = (mode, specs) =>
    mode === PRODUCT_CARD_MODE.LIST ||
    (mode === PRODUCT_CARD_MODE.LIST_SPEC && (!specs || specs?.length === 0));

export const showAsListSpec = (mode, specs) =>
    mode === PRODUCT_CARD_MODE.LIST_SPEC && !!specs?.length;

export const getIsProProduct = (product, hasB2B) => {
    let value;
    if (product.market === 'b2c') value = product.banner === 'b2b' && hasB2B;
    else if (product.market === 'b2b')
        value = product.has_pro_conditions && hasB2B;

    return value;
};

export const getImageBlockMode = (mode, IMAGE_BLOCK_MODE) => {
    if (mode === PRODUCT_CARD_MODE.GRID_VISUAL) {
        return IMAGE_BLOCK_MODE.VISUAL;
    }

    return IMAGE_BLOCK_MODE.DEFAULT;
};
